import {Alarm} from '@web/core/constants'
import makeSlice from '@web/slices/purchaser/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {
                data: {purchaser, containsTraditionalAlcohol, naverMembership},
            } = payload

            /** 알림 수신 수단이 SMS인 경우, 수신 수단 업데이트 필요 */
            state.shouldUpdateAlarmType = purchaser.alarmType === Alarm.SMS
            state.alarmType = purchaser.alarmType

            state.adult = purchaser.adult
            state.child = purchaser.child
            state.emailAddress = purchaser.emailAddress
            state.name = purchaser.name ?? ''
            state.phoneNumber = purchaser.phoneNumber
            state.duplicatePhoneNumberUsingMember = purchaser.duplicatePhoneNumberUsingMember
            state.naverIdNo = purchaser.nidno ?? ''

            state.adultAuthentication.isRequired = containsTraditionalAlcohol ?? false

            state.naverMembership = {
                currentEpisode: naverMembership.currentEpisode,
                membershipBenefitLayerExposed: naverMembership.membershipBenefitLayerExposed,
                membershipPlcc: naverMembership.membershipPlcc,
                subscribed: naverMembership.subscribed,
                shouldShowQuickJoinMembershipBanner: naverMembership.quickJoinMembershipBannerExposure,
            }
        })
    },
})

export default slice.reducer
